import {
  CHANGE_LAWYER,
  CHANGE_COMPANY,
  CHANGE_NEW_INVITATION_CLASSIFIERS,
  CHANGE_OPTIONAL,
} from './actions'

export default function(state = {
  lawyer: {},
  company: {},
  classifiers: [],
  optional: {
    ps: true,
    classifiers: true
  },
}, action) {
  switch(action.type) {
    case CHANGE_LAWYER:
      return { ...state, lawyer: action.payload }
    case CHANGE_COMPANY:
      return { ...state, company: action.payload }
    case CHANGE_NEW_INVITATION_CLASSIFIERS:
      return { ...state, classifiers: action.payload }
    case CHANGE_OPTIONAL:
      return { ...state, optional: action.payload }
    default:
      return state
  }
}
